/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMessageStatusUnread = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M12.5 8a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0z"
    />
    <path fill="currentColor" d="M8 3.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z" />
  </svg>
);

IconMessageStatusUnread.displayName = 'IconMessageStatusUnread';

IconMessageStatusUnread.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMessageStatusUnread);
IconMessageStatusUnread.displayName = 'IconMessageStatusUnread';
